<template>
  <div class="home" v-lazy:background-image="background">
    <Letter />
    <Information />
    <TimelineLarge />
    <TimelineSmall />
  </div>
</template>

<script>
import Letter from "@/components/home/Letter.vue";
import Information from "@/components/home/Information.vue";
import TimelineLarge from "@/components/home/timeline/Large.vue";
import TimelineSmall from "@/components/home/timeline/Small.vue";

import background from "@/assets/home/background.jpg";
import backgroundL from "@/assets/home/background-l.jpg";

export default {
  name: "home",
  components: {
    Letter,
    Information,
    TimelineLarge,
    TimelineSmall
  },
  data() {
    return {
      background: {
        src: background,
        loading: backgroundL
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.home {
  background-position: center;
  background-repeat: no-repeat;
  padding: 1rem;

  height: 100%;

  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-areas:
    "letter   information"
    "letter   information"
    "letter   information"
    "timeline-large timeline-large";
}

@media screen and (max-width: 1366px) {
  .home {
    grid-template-columns: 60% 40%;
  }
}

@media screen and (max-width: 1024px) {
  .home {
    grid-template-columns: 100%;
    grid-template-rows: repeat(auto, 3);
    grid-template-areas: "information" "letter" "timeline-small";
  }
}

@media screen and (max-width: 767px) {
  .home {
    grid-template-rows: 0.6fr 1fr 0.325fr;
  }
}
</style>
